/** S3 folders available for uploading. */
export enum S3Folder {
  Files = 'files',
}
